<template>
    <div class="clearfix">
        <div class="newListBox">
            <div class="p_news">
                <div
                    class="newList"
                    v-for="item in list"
                    :key="item.F_Id"
                    @click="jumpPage(item.F_Id)"
                >
                    <a class="newLinkBox">
                        <div class="leftTimeBox">
                            <div class="newData"> {{ item.F_CreatorTime | toDay }}</div>
                            <div class="newYearMon">
                                {{ item.F_CreatorTime | toYearMonth }}
                            </div>
                        </div>
                        <div class="centerContentBox">
                            <h2 class="newTitle">
                                {{ item.F_Title }}
                            </h2>
                            <article class="newSummry">
                                {{ item.F_Sketch }}
                            </article>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <img
            src="../../../../../src/assets/img/mainPage/join us.png"
            class="imgboxbg" @click="goto('/recruit')" style="cursor: pointer;"
        />
    </div>
</template>

<script>
import { getData } from '../../../../service/secondHttp'
export default {
    data() {
        return {
            list: [],
            query: {
                page: 1,
                rows: 3,
                sidx: 'F_CreatorTime',
                sord: 'desc',
                category: '1',
            },
        }
    },
    methods: {
        getData() {
            getData('Article', this)
        },
        jumpPage(id) {
            this.$router.push('/newsDetail/' + id+'/14')
        },
        goto(url) {
            this.$router.push(url)
        }
    },
    mounted() {
        this.getData()
    },
}
</script>

<style scoped lang="less">
.newList:hover {
    height: auto;
}
.newList:hover .leftTimeBox {
    background: #01af57;
    color: #fff;
}
.newList:hover .newTitle {
    color: #01af57;
}
.leftTimeBox {
    width: 80px;
    height: 80px;
    background: #fff;
    text-align: center;
    color: #595959;
    transition: all 0.5s ease;
    padding-bottom: 15px;
    font-family: Arial;
}
.newLinkBox {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    height: 100%;
    padding-right: 0%;
    overflow: hidden;
}
.newData {
    font-size: 28px;
    line-height: 46px;
    padding-top: 5px;
}
.newTitle {
    font-size: 18px;
    color: #333;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    transition: all 0.5s ease;
    font-weight: bold;
    line-height: 36px;
}
.newSummry {
    line-height: 20px;
    height: 42px;
    overflow: hidden;
    color: #999;
    font-size: 14px;
}
.centerContentBox {
    width: calc((100% - 80px) / 1);
    padding-left: 3%;
}
.newList {
    overflow: hidden;
    width: 100%;
    height: auto;
    padding-bottom: 14px;
    margin-bottom: 20px;
    border-bottom: 1px dashed #cfcbca;
    transition: all 0.5s ease;
}
.newListBox {
    float: left;
    width: 59.4%;
    padding-right: 49px;
    margin-top: -12px;
}
.imgboxbg {
    float: left;
    margin-left: 3em;
    width: 35%;
}
</style>
